import { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { Alert, Snackbar } from "@mui/material";
import { Table, TableBody, TableCard, TableCell, TableHead, TableHeaderWrap, TableRow, } from "../../../../component/table/table-layout";
// import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
// import CustomizeTabsPopup from "../../../../component/table/customize-table";
// import moment from "moment";
// import { Link } from "react-router";
// import StatusChip from "../../../../component/ui/chip/status";
// import AvatarProfile from "../../../../component/ui/profile";
import { TitleHeading } from "../../../../component/ui/layout";
import { FeildWraper } from "../../../../component/form/form-layout";
import moment from "moment";

const WaterTankerTrendList = () => {

  const [alertData, setAlertData] = useState({ isShow: false });
  const [isMothlyLoading, setIsMothlyLoading] = useState(true);
  const [monthlyData, setMonthlyData] = useState([]);
  const [monthlyHeader, setMonthlyHeader] = useState([]);
  const [years, setYears] = useState([]);
  const [customYear, setCustomYear] = useState("")
  const tableRef = useRef(null);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getMonthlyData()
  }, [customYear]) //customYear

  const getMonthlyData = async () => {
    setIsMothlyLoading(true);
    try {
      // ?year=${customYear}
      let apiRes = await apiCall({ method: "get", url: `get-monthly-water-tanker-trends${customYear ? `?year=${customYear}`: ""}` })
      setMonthlyData(apiRes?.data);
      setMonthlyHeader(apiRes?.headers)
      setIsMothlyLoading(false)
    } catch (error) {
      console.log("Err", error)
    }
  }

  useEffect(() => {
    let customYear = [];
    let currentYear = moment(new Date()).format("YYYY");
    for (let i = 2025; i <= currentYear; i++) {
      customYear.push(i);
    }
    setYears(customYear);
  }, []);

  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className={Style.report_table__header}>
          <span className={Style.report_table__title}>
            <TitleHeading title={`Monthly Trends`} />
          </span>

          <div className="">
            <FeildWraper className={"!w-full !py-0"}>
              <select value={customYear} onChange={(e) => {setCustomYear(e.target.value)}} className="!w-[180px]">
                <option value="">Last 12 Months</option>
                {years?.map((eachYear, index) => (
                  <option value={eachYear} key={index}>{eachYear}</option>
                ))}
                {/* <option value="">2024</option>
                <option value="">2023</option>
                <option value="">2022</option> */}
              </select>
            </FeildWraper>
          </div>
          {/* <div className={Style.bpfl_action}>
          </div> */}
        </div>

        <div className={Style.LeaveBody}>
          {/* isLoading ||  */}
          {(isMothlyLoading) ? (
            <InnerLoader />
          ) : (
            <>
              <TableCard ref={tableRef}>
                <div className={"flex flex-col gap-6"}>
                  {/* {
                    !lists?.length ?
                      <DataNotFound title={"Yearly Data"} />
                      :
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <div className="flex gap-4 items-center">
                                <span>Year</span>
                              </div>
                            </TableCell>
                            {tableHeaders?.map((eachHead, index) =>
                              eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {lists?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  <div className={`${Style.tableActionArea} !gap-4`}>
                                    <div className="flex gap-[10px]">
                                      <div className="flex items-center gap-3">
                                        <div className="font-semibold text-[15px] leading-5 underline decoration-dotted cursor-pointer underline-offset-4" onClick={() => { setCustomYear(eachList?.year) }}>{eachList?.year}</div>
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>

                                {tableHeaders?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                                    <>
                                      {eachHead.key === "status" ? (
                                        <TableCell
                                          key={`${i}-${index}`}
                                          className={`text-center`}
                                        >
                                          {eachList[eachHead?.key] === "Assigned" ? (
                                            <StatusChip color="green">{eachList[eachHead?.key] || "--"}</StatusChip>
                                          ) : eachList[eachHead?.key] === "Retired" ? (
                                            <StatusChip color="red">{eachList[eachHead?.key] || "--"}</StatusChip>
                                          ) : eachList[eachHead?.key] === "Under Repair" ? (
                                            <StatusChip color="purple">{eachList[eachHead?.key] || "--"}</StatusChip>
                                          ) : (
                                            <StatusChip color="blue">{eachList[eachHead?.key] || "--"}</StatusChip>
                                          )}
                                        </TableCell>
                                      ) : eachHead.key === "assigned_to_department" ? (
                                        <TableCell key={`${i}-${index}`}>
                                          <div className="flex flex-wrap gap-2 max-w-[550px]">
                                            {eachList?.assigned_to_department ? (
                                              eachList.assigned_to_department.split(",").map((dep, index) => (
                                                <TableDepartmentTag
                                                  title={dep.trim()}
                                                />
                                              ))
                                            ) : (
                                              "-"
                                            )}
                                          </div>
                                        </TableCell>
                                      ) : eachHead.key === "assigned_to_designation" ? (
                                        <TableCell key={`${i}-${index}`}>
                                          <div className="flex flex-wrap gap-2 max-w-[550px]">
                                            {eachList?.assigned_to_designation ? (
                                              eachList?.assigned_to_designation.split(",").map((des, index) => (
                                                <span>{des.trim()}</span>
                                              ))
                                            ) : (
                                              "-"
                                            )}
                                          </div>
                                        </TableCell>
                                      ) : eachHead.key === "created_by" ? (
                                        <TableCell key={`${i}-${index}`}>
                                          <AvatarProfile
                                            title={eachList?.created_by}
                                            src={eachList?.created_by_profile_picture?.split(",")[index]?.trim()}
                                          />
                                        </TableCell>
                                      ) : (
                                        <TableCell key={`${i}-${index}`}>
                                          {(eachList[eachHead?.key]) ? (typeof eachList[eachHead?.key] == "string" && eachList[eachHead?.key]?.slice(0, 5) == "https") ? <Link to={eachList[eachHead?.key]} target="_blank" className="text-blue-600 underline">View</Link> : eachList[eachHead?.key] : "-"}
                                        </TableCell>
                                      )}
                                    </>
                                  ) : null
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                  } */}

                  {!monthlyData?.length ?
                    <DataNotFound title={"Monthly Data"} />
                    :
                    <>
                      {/* <TitleHeading title={`Monthly Fuel Summary (${customYear ? customYear : moment().format("YYYY")})`} /> */}
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <div className="flex gap-4 items-center">
                                <span>Month</span>
                              </div>
                            </TableCell>

                            {
                              monthlyHeader?.map((h_ele, h_idx) => 
                                (h_ele.show == 1 && h_ele?.is_visible == 1) ?
                                  <TableCell header>
                                    <TableHeaderWrap>
                                      <span>{h_ele?.value}</span>
                                    </TableHeaderWrap>
                                  </TableCell>
                                  :null
                              )
                            }
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {monthlyData?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  <div className={`${Style.tableActionArea} !gap-4`}>
                                    <div className="flex gap-[10px]">
                                      <div className="flex items-center gap-3">
                                        <div className="font-semibold text-[15px] leading-5">{eachList?.month}</div>
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>

                                {
                                  monthlyHeader?.map((h_ele, h_idx) => 
                                    (h_ele.show == 1 && h_ele?.is_visible == 1) ?
                                    <TableCell key={`mon_${h_idx}_${index}`}>
                                      <TableHeaderWrap>
                                        <span>{eachList[h_ele?.key]}</span>
                                      </TableHeaderWrap>
                                    </TableCell>
                                    :
                                    null
                                  )
                                }
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </>
                  }
                </div>
              </TableCard>
            </>
          )}
        </div>
      </div>

      {/* {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            setShowModalFilterTable(false);
            setFilterReturn(filters);
            setSelectFilterName(filterName);
            setEditingFilters(editingFilter);
            getData({ filter: filters });
          }}
          selectFilterName={selectFilterName}
          editingFilters={editingFilters}
          saveFilter={saveFilter}
          apiUrl="assets-list"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="assets-list"
        />
      )} */}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default WaterTankerTrendList;
